import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthenticationService } from './authentication.service';
import { SecurityService } from './security.service';

@Injectable()
export class TokenInterceptorService implements HttpInterceptor {
  constructor(public authenticationService: AuthenticationService,private securityService:SecurityService){}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const roleName = this.securityService.isUserAuthorized ? this.securityService.LOGGED_USER.roleName?.toLowerCase() : '';
    let baseUrl: string | undefined;
    if (roleName?.includes('vehicle')) {
      baseUrl = environment.routeMapVehicle.get(window.location.hostname) ?? environment.routeMapVehicle.get('default');
    } else {
      baseUrl = environment.routeMapParts.get(window.location.hostname) ?? environment.routeMapParts.get('default');
    }

    const isApiCall = req.url.includes('/api');
    const userToken = this.authenticationService.userInfo.token;
    const modifiedReq = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${userToken}`),
      url: isApiCall? baseUrl+req.url:req.url
    });

   // console.log('req url  '+modifiedReq.url);
    console.log('env   '+environment.environmentName);

    if( isApiCall && this.securityService.LOGGED_USER){
      this.securityService.LOGGED_USER.lastAccessedTime=new Date();
      //console.log("==== updated last access time === ",this.securityService.LOGGED_USER.lastAccessedTime);
    }

    return next.handle(modifiedReq).pipe(
      catchError((err: any) => {
        if(isApiCall && (403 === err.status || 401 === err.status)) {
          //console.log("Token expired, error status "+err.status);
          this.authenticationService.logout();
        }
        return throwError(err);
      })
    );
  }

}
